(function () {
  'use strict';

  // Shopify's Cart AJAX API HTML-encodes property values (&#39;, &amp;, ...).
  // Decode before comparing so drift detection doesn't produce false positives.
  var _decodeEl = null;
  function htmlDecode(s) {
    if (typeof s !== 'string') return s;
    if (!_decodeEl) _decodeEl = document.createElement('textarea');
    _decodeEl.innerHTML = s;
    return _decodeEl.value;
  }
  function decodeProps(obj) {
    if (!obj || typeof obj !== 'object') return {};
    var out = {};
    Object.keys(obj).forEach(function (k) { out[k] = htmlDecode(obj[k]); });
    return out;
  }

  var state = { inFlight: false, lastSignature: '', postsPromise: Promise.resolve() };

  function extractWork() {
    var els = document.querySelectorAll('[data-reconcile-note]');
    var work = [];
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var key = el.getAttribute('data-key');
      if (!key) continue;
      var existingProps = {};
      var raw = el.getAttribute('data-line-properties');
      if (raw) { try { existingProps = JSON.parse(raw); } catch (e) {} }
      work.push({
        key: key,
        expected: el.getAttribute('data-reconcile-note') || '',
        existingProps: decodeProps(existingProps)
      });
    }
    return work;
  }

  function runWork(work) {
    if (!work.length) return Promise.resolve();
    var chain = Promise.resolve();
    work.forEach(function (line) {
      chain = chain.then(function () {
        var merged = Object.assign({}, line.existingProps);
        if (line.expected === '') {
          delete merged.Note;
          merged._Note = '';
        } else {
          merged.Note = line.expected;
        }
        return fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: line.key, properties: merged })
        });
      });
    });
    return chain.then(null, function (err) {
      console.warn('[persistent-note] reconcile failed', err);
    });
  }

  function reconcile() {
    var work = extractWork();
    var sig = work.map(function (w) { return w.key + ':' + w.expected; }).join('|');
    if (!sig) return Promise.resolve();
    if (state.inFlight) return state.postsPromise;
    if (sig === state.lastSignature) return Promise.resolve();
    state.lastSignature = sig;
    state.inFlight = true;
    state.postsPromise = runWork(work);
    state.postsPromise.then(
      function () { state.inFlight = false; },
      function () { state.inFlight = false; }
    );
    return state.postsPromise;
  }

  document.addEventListener('DOMContentLoaded', reconcile);

  // After cart re-renders (add-to-cart fires this), give DOM time to update then reconcile.
  document.addEventListener('cart:item-added', function () {
    setTimeout(reconcile, 150);
  });
})();
